<template>
    <div class="card p-fluid">
        <h5>Relatório de Chamados</h5>
        <div class="grid p-fluid mt-2 ml-2">
            <div class="field col-12 md:col-3 lg:col-2">
                <label class="required" for="inicio">Inicio</label>
                <Calendar v-model="inicio" dateFormat="dd/mm/yy" itemid="inicio" />
            </div>
            <div class="field col-12 md:col-3 lg:col-2">
                <label class="required" for="fim">Fim</label>
                <Calendar v-model="fim" dateFormat="dd/mm/yy" itemid="fim" />
            </div>

            <div class="col-12 md:col-6 lg:col-6 flex flex-wrap">
                <div class="flex align-items-center mr-3">
                    <RadioButton v-model="tipoRelatorio" inputId="radioPRODUTO_REAL" name="tipoRelatorio" value="PRODUTO_REAL" />
                    <label for="radioPRODUTO_REAL" class="ml-2">Produto Real</label>
                </div>
                <div class="flex align-items-center">
                    <RadioButton v-model="tipoRelatorio" inputId="radioCURADORIA" name="tipoRelatorio" value="CURADORIA" />
                    <label for="radioCURADORIA" class="ml-2">Curadoria</label>
                </div>
            </div>
        </div>
    </div>
    <Button label="Gerar Relatório" @click="gerarPlanilhaXlsx" :disabled="!inicio || !fim" icon="pi pi-file-excel"></Button>
</template>
<script>
import Services from './service';

export default {
    name: 'RelatorioChamado',
    components: {},
    data() {
        return {
            inicio: null,
            fim: null,
            tipoRelatorio: 'PRODUTO_REAL',
        };
    },
    methods: {
        mesnsagemErro(mensagem) {
            this.$toast.add({
                severity: 'error',
                summary: 'Erro',
                detail: mensagem,
            });
        },

        gerarPlanilhaXlsx() {
            this.$store.dispatch('addRequest');
            let inicioFmt = this.$moment(this.inicio).format('YYYY-MM-DD');
            let fimFmt = this.$moment(this.fim).format('YYYY-MM-DD');

            if (inicioFmt > fimFmt) {
                this.$store.dispatch('removeRequest');
                this.mesnsagemErro('Data inicial não pode ser maior que a data final');
            } else {
                let promisse;
                if (this.tipoRelatorio == 'PRODUTO_REAL') {
                    promisse = Services.gerarRelatorioProdutoReal(inicioFmt, fimFmt);
                } else {
                    promisse = Services.gerarRelatorioCuradoria(inicioFmt, fimFmt);
                }
                promisse.then((response) => {
                    if (response?.success) {
                        this.$download(
                            response.data,
                            `RELATORIO_${this.tipoRelatorio}_${this.$moment(this.inicio).format('DD-MM-YYYY')}_${this.$moment(this.fim).format(
                                'DD-MM-YYYY'
                            )}.xls`
                        );
                    } else {
                        this.mesnsagemErro('Erro ao gerar planilha');
                    }
                    this.$store.dispatch('removeRequest');
                });
            }
        },
    },
};
</script>
